import { useEffect, useState } from "react"
import { CartMinimums } from "../../storeApi"

// one request for the same cart, whoever asks (the seller headers and the footer)
let last = { key: "", promise: null }
const minimumsFor = (cart, key) => {
  if (last.key !== key) last = { key, promise: CartMinimums(cart.map((line) => ({ pid: line.pid, quantity: line.quantity || 1 }))).then((result) => result?.minimums || []).catch(() => []) }
  return last.promise
}

/**
 * Each seller in the cart with a minimum order (vendor Delivery → Settings), asked for whenever the cart's
 * products change: [{ sellerId, sellerName, amount, remaining, currency, met }]. A seller without one is not in
 * the answer. null until it is known. The checkout waits until every one is met.
 */
export function useCartMinimums(cart) {
  const [minimums, setMinimums] = useState(null)
  const key = cart.map((line) => `${line.pid}:${line.quantity || 1}`).join(",")

  useEffect(() => {
    if (!cart.length) return setMinimums([])
    let alive = true
    minimumsFor(cart, key).then((answer) => alive && setMinimums(answer))
    return () => {
      alive = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key])

  return minimums
}
